const normalizeSocialLabel = (value: string) => value.trim().toLowerCase().replace(/[^a-z0-9]/g, '')

export const SocialIcon = ({ label }: { label: string }) => {
  const normalized = normalizeSocialLabel(label)

  if (normalized.includes('facebook')) {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
        <path
          fill="currentColor"
          d="M13.5 8.25V6.9c0-.8.37-1.3 1.3-1.3h1.2V3.2h-1.97c-2.37 0-3.53 1.45-3.53 3.53v1.52H8.6v2.6h1.9V20h3V10.85h2.1l.3-2.6h-2.4z"
        />
      </svg>
    )
  }
  if (normalized.includes('instagram')) {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
        <path
          fill="currentColor"
          d="M7.75 3h8.5A4.75 4.75 0 0 1 21 7.75v8.5A4.75 4.75 0 0 1 16.25 21h-8.5A4.75 4.75 0 0 1 3 16.25v-8.5A4.75 4.75 0 0 1 7.75 3zm0 1.8A2.95 2.95 0 0 0 4.8 7.75v8.5a2.95 2.95 0 0 0 2.95 2.95h8.5a2.95 2.95 0 0 0 2.95-2.95v-8.5a2.95 2.95 0 0 0-2.95-2.95h-8.5zm8.9 1.15a1.05 1.05 0 1 1 0 2.1 1.05 1.05 0 0 1 0-2.1zM12 7.8A4.2 4.2 0 1 1 7.8 12 4.2 4.2 0 0 1 12 7.8zm0 1.8A2.4 2.4 0 1 0 14.4 12 2.4 2.4 0 0 0 12 9.6z"
        />
      </svg>
    )
  }
  if (normalized === 'x' || normalized.includes('twitter')) {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
        <path fill="currentColor" d="M5 4h3.2l4.05 5.53L17 4h2.1l-5.9 6.83L20 20h-3.2l-4.58-6.23L6.8 20H4.7l6.34-7.34L5 4z" />
      </svg>
    )
  }
  if (normalized.includes('linkedin')) {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
        <path
          fill="currentColor"
          d="M6.2 8.2A1.6 1.6 0 1 1 6.2 5a1.6 1.6 0 0 1 0 3.2zM4.8 9.7h2.8V19H4.8V9.7zm4.7 0h2.7v1.27h.04c.38-.72 1.31-1.48 2.7-1.48 2.88 0 3.41 1.9 3.41 4.38V19h-2.8v-4.45c0-1.06-.02-2.43-1.48-2.43-1.48 0-1.7 1.16-1.7 2.35V19h-2.87V9.7z"
        />
      </svg>
    )
  }
  if (normalized.includes('youtube')) {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
        <path
          fill="currentColor"
          d="M20.5 8.2a2.2 2.2 0 0 0-1.55-1.56C17.55 6.25 12 6.25 12 6.25s-5.55 0-6.95.39A2.2 2.2 0 0 0 3.5 8.2c-.4 1.41-.4 3.8-.4 3.8s0 2.39.4 3.8a2.2 2.2 0 0 0 1.55 1.56c1.4.39 6.95.39 6.95.39s5.55 0 6.95-.39a2.2 2.2 0 0 0 1.55-1.56c.4-1.41.4-3.8.4-3.8s0-2.39-.4-3.8zM10.2 14.45V9.55L14.5 12l-4.3 2.45z"
        />
      </svg>
    )
  }

  return <span className="text-[10px] font-bold">{label.trim().slice(0, 2).toUpperCase()}</span>
}
